import { render, staticRenderFns } from "./CommonRight.vue?vue&type=template&id=1ffd556a&scoped=true"
import script from "./CommonRight.vue?vue&type=script&lang=js"
export * from "./CommonRight.vue?vue&type=script&lang=js"
import style0 from "./CommonRight.vue?vue&type=style&index=0&id=1ffd556a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd556a",
  null
  
)

export default component.exports